import { ref } from "vue";
import type { ResponseTraitError } from "@/types/Error/Error";

export interface ErrorHandlerState {
	show403: boolean;
	show500: boolean;
	errorMessage: string;
}

const errorState = ref<ErrorHandlerState>({
	show403: false,
	show500: false,
	errorMessage: "",
});

export function useErrorHandler() {
	const handleError = (error: ResponseTraitError | Error | unknown) => {
		if (isResponseTraitError(error)) {
			switch (error.status) {
				case 403:
					errorState.value.show403 = true;
					errorState.value.errorMessage = error.message || "Acesso não autorizado";
					break;
				case 500:
				case 502:
				case 503:
					errorState.value.show500 = true;
					errorState.value.errorMessage = error.message || "Erro interno do servidor";
					break;
				default:
					console.error("Error:", error);
			}
		} else if (error instanceof Error && "status" in error) {
			const statusError = error as Error & { status: number };
			switch (statusError.status) {
				case 403:
					errorState.value.show403 = true;
					errorState.value.errorMessage = error.message || "Acesso não autorizado";
					break;
				case 500:
				case 502:
				case 503:
					errorState.value.show500 = true;
					errorState.value.errorMessage = error.message || "Erro interno do servidor";
					break;
				default:
					console.error("Error:", error);
			}
		} else {
			console.error("Unknown error:", error);
		}
	};

	const reset403 = () => {
		errorState.value.show403 = false;
		errorState.value.errorMessage = "";
	};

	const reset500 = () => {
		errorState.value.show500 = false;
		errorState.value.errorMessage = "";
	};

	const resetAll = () => {
		errorState.value.show403 = false;
		errorState.value.show500 = false;
		errorState.value.errorMessage = "";
	};

	return {
		errorState,
		handleError,
		reset403,
		reset500,
		resetAll,
	};
}

function isResponseTraitError(obj: unknown): obj is ResponseTraitError {
	return (
		typeof obj === "object" &&
		obj !== null &&
		"message" in obj &&
		"status" in obj &&
		typeof (obj as ResponseTraitError).status === "number"
	);
}
